<template>

  <svg
    t="1640067016334"
    class="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="4028"
    width="64"
    height="64"
  ><path d="M897.00000031 92H126.99999969A34.99999969 34.99999969 0 0 0 92 126.99999969V711.99999969a34.99999969 34.99999969 0 0 0 34.99999969 35.00000062h350.00000062v114.99999938h-194.80000031a34.99999969 34.99999969 0 1 0 0 70.00000031h460.00000031a34.99999969 34.99999969 0 1 0 0-70.00000031h-195.20000062v-114.79999969h350.00000062A34.99999969 34.99999969 0 0 0 932 711.99999969V126.99999969A34.99999969 34.99999969 0 0 0 897.00000031 92zM861.99999969 677.19999969h-699.99999938V162.00000031h699.99999938z" p-id="4029" /><path d="M315.2 519.00000031a34.2 34.2 0 0 0 21.19999969-7.00000031l106.40000062-81.6L531.99999969 505.20000031a34.99999969 34.99999969 0 0 0 44.4 0l155.00000062-123.20000062a34.99999969 34.99999969 0 0 0-43.60000031-54.79999969l-132.40000031 105.40000031-87.99999938-74.80000031a34.99999969 34.99999969 0 0 0-44.00000062-1.00000031l-128.79999938 98.80000031a34.99999969 34.99999969 0 0 0 21.39999938 62.80000031z" p-id="4030" /></svg>


</template>

<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'JtIconPreview',
} as DefineComponent
</script>